// src/components/Navbar.jsx
import React from 'react';
import styled from 'styled-components';
import UserAvatar from './UserAvatar';
import { useUser } from '../hooks/useUser';

const Nav = styled.nav`
  background-color: #1f2937;
  padding: 1rem;
  color: white;
`;

const NavContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const StyledLink = styled.a`
  color: white;
  text-decoration: none;
  padding: 0.5rem;
  transition: color 0.3s;
  cursor: pointer;

  &:hover {
    color: #d1d5db;
  }
`;

const HelpButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  transition: border-color 0.2s, color 0.2s, background 0.2s;

  &:hover {
    border-color: white;
    color: white;
    background: rgba(255, 255, 255, 0.1);
  }
`;

const LoadingAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #374151;
  border: 2px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::after {
    content: '';
    width: 20px;
    height: 20px;
    border: 2px solid #ffffff;
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Navbar = ({ onNavigate }) => {
  const { user, loading, logout, getAvatarUrl, navigateToProfile } = useUser();

  const handleNavClick = (path) => {
    if (onNavigate) {
      onNavigate(path);
    } else {
      window.location.href = path;
    }
  };

  const handleProfileNavigation = () => {
    if (onNavigate) {
      onNavigate('/profile');
    } else {
      navigateToProfile();
    }
  };

  return (
    <Nav>
      <NavContainer>
        <NavLinks>
          <StyledLink onClick={() => handleNavClick('/home')}>
            Home
          </StyledLink>
          <StyledLink onClick={() => handleNavClick('/dashboard')}>
            Dashboard
          </StyledLink>
          <StyledLink onClick={() => handleNavClick('/search')}>
            Search
          </StyledLink>
          <StyledLink onClick={() => handleNavClick('/investigate')}>
            Investigate
          </StyledLink>
          <StyledLink onClick={() => handleNavClick('/about')}>
            About
          </StyledLink>
        </NavLinks>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          {loading ? (
            <LoadingAvatar />
          ) : (
            <UserAvatar
              user={user}
              onLogout={logout}
              getAvatarUrl={getAvatarUrl}
              onNavigateToProfile={handleProfileNavigation}
            />
          )}
          <HelpButton onClick={() => handleNavClick('/api-docs')} title="API Documentation">
            ?
          </HelpButton>
        </div>
      </NavContainer>
    </Nav>
  );
};

export default Navbar;